(function ($) {
	$.fn.lmSponsorslider = function(options) {
		// NOTE: Don't run logic below if nothing is in the dom
		if (!this.length) {
			return false;
		}
		
		// Default settings are set here
		var settings = $.extend({
			nextButton: '.sponsor-slider__next',
			prevButton: '.sponsor-slider__prev',
			selector: '.sponsor-slider__track',
			slideTimer: 4000,
			autoplay: true
		}, options);
		
		// These are all the methods available for the plugin
		var methods = {};

		methods.initContext = function($context) {
			var $track = $context.find(settings.selector);
			$track.slick({
				arrows: true,
				nextArrow: settings.nextButton,
				prevArrow: settings.prevButton,
				autoplay: settings.autoplay,
				autoplaySpeed: settings.slideTimer,
				slidesToShow: 10,
				responsive: [{
					breakpoint: 1220,
					settings: {
						slidesToShow: 7
					}
				},{
					breakpoint: 1040,
					settings: {
						slidesToShow: 6
					}
				},{
					breakpoint: 860,
					settings: {
						slidesToShow: 5
					}
				},{
					breakpoint: 680,
					settings: {
						slidesToShow: 4
					}
				},{
					breakpoint: 590,
					settings: {
						slidesToShow: 3
					}
				},{
					breakpoint: 500,
					settings: {
						slidesToShow: 2
					}
				},{
					breakpoint: 320,
					settings: {
						slidesToShow: 2
					}
				}]
			});

			$context.data('initialized', true);
		}
		
		// Filter each function
		methods.filterEach = function() {
			return !$(this).data("initialized");
		}
		
		// Methods to run inside loop
		return this.filter(methods.filterEach).each(function() {
			var $this = $(this);
			// NOTE: Method you'd like initialized on a per context basis
			methods.initContext($this);
		});
};

}(jQuery));
